// @flow
import { connect } from 'react-redux';

import RencontreHeader, { type StateProps } from 'components/rencontre/RencontreHeader';

import type { StateType } from 'types/Actions';

const mapStateToProps = (state: StateType): StateProps => ({
  status: state.rencontreState.status,
  competitionsEquipes: state.settingsState.competitionsEquipes,
  clubName: state.settingsState.title,
  rencontre: state.rencontreState.rencontre,
  album: state.albumState.album,
  albumStatus: state.albumState.albumStatus,
});

export default connect(mapStateToProps)(RencontreHeader);
